import type { BackendModule } from 'i18next';

const LazyImportPlugin: BackendModule = {
  type: 'backend',
  init() {
    // require
  },
  read(language, namespace, callback) {
    void import(`../public/locales/${language}/${namespace}.json`).then(
      (obj) => {
        callback(null, obj);
      },
    );
  },
};
export default LazyImportPlugin;
